<template>
<div class="relative bg-gray-50 pt-16 pb-10 px-4 sm:px-6 lg:pt-20 lg:pb-14 lg:px-8">
            <div class="absolute inset-0">
              <div class="bg-white h-1/3 sm:h-2/3"></div>
            </div>
            <div class="relative max-w-7xl mx-auto">
              <div class="text-center">
                <h2 class="text-3xl leading-9 tracking-tight font-extrabold text-gray-900 sm:text-4xl sm:leading-10">
                  All our services
                </h2>
                <p class="mt-3 max-w-2xl mx-auto text-xl leading-7 text-gray-500 sm:mt-4">
                    <!-- subtext goes here -->
                </p>
              </div>
              <div class="mt-12 grid gap-5 max-w-lg mx-auto lg:grid-cols-4 lg:max-w-none">
                <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
                  <div class="flex-shrink-0">
                    <img class="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1465447142348-e9952c393450?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=350&q=100" alt="" />
                  </div>
                  <div class="flex-1 bg-white p-6 flex flex-col justify-between">
                    <div class="flex-1">
                      <p class="text-sm leading-5 font-medium text-indigo-600">
                        <a href="#" class="hover:underline">
                        Traffic Analysis
                        </a>
                      </p>
                      <a href="#" class="block">
                        <h3 class="mt-2 text-xl leading-7 font-semibold text-gray-900">
                          Drone Traffic
                        </h3>
                        <p class="mt-3 text-base leading-6 text-gray-500">
                          <ul>
                            <li class="flex items-start">
                              <div class="flex-shrink-0">
                                <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                </svg>
                              </div>
                              <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                Traffic Counts
                              </p>
                            </li>
                            <li class="flex items-start">
                              <div class="flex-shrink-0">
                                <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                </svg>
                              </div>
                              <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                Parking Surveys
                              </p>
                            </li>
                            <li class="flex items-start">
                              <div class="flex-shrink-0">
                                <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                </svg>
                              </div>
                              <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                Queue Surveys
                              </p>
                            </li>
                            <li class="flex items-start">
                                <div class="flex-shrink-0">
                                  <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                  </svg>
                                </div>
                                <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                  Vehicle Speed Surveys
                                </p>
                              </li>
                              <li class="flex items-start">
                                <div class="flex-shrink-0">
                                  <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                  </svg>
                                </div>
                                <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                  Origin-Destination Surveys
                                </p>
                              </li>
                        </ul>
                        </p>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
                  <div class="flex-shrink-0">
                    <img class="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1528312635006-8ea0bc49ec63?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=350&q=100" alt="" />
                  </div>
                  <div class="flex-1 bg-white p-6 flex flex-col justify-between">
                    <div class="flex-1">
                      <p class="text-sm leading-5 font-medium text-indigo-600">
                        <a href="#" class="hover:underline">
                          Traffic Analysis
                        </a>
                      </p>
                      <a href="#" class="block">
                        <h3 class="mt-2 text-xl leading-7 font-semibold text-gray-900">
                            Fixed Cameras
                        </h3>
                        <p class="mt-3 text-base leading-6 text-gray-500">
                            <ul>
                                <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                        <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                          </svg>
                                          </div>
                                  <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                    Transport Insights
                                  </p>
                                </li>
                                <li class="flex items-start">
                                  <div class="flex-shrink-0">
                                    <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                    </svg>
                                  </div>
                                  <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                    Origin-Destination Surveys
                                  </p>
                                </li>
                                <li class="flex items-start">
                                  <div class="flex-shrink-0">
                                    <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                    </svg>
                                  </div>
                                  <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                    Traffic Survey
                                  </p>
                                </li>
                                <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      Active Travel
                                    </p>
                                  </li>
                            </ul>
                        </p>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
                    <div class="flex-shrink-0">
                      <img class="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1482169704817-5b66aafa1a01?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=350&q=100" alt="" />
                    </div>
                    <div class="flex-1 bg-white p-6 flex flex-col justify-between">
                      <div class="flex-1">
                        <p class="text-sm leading-5 font-medium text-indigo-600">
                          <a href="#" class="hover:underline">
                            Artificial Intelligence
                          </a>
                        </p>
                        <a href="#" class="block">
                          <h3 class="mt-2 text-xl leading-7 font-semibold text-gray-900">
                            Drone Pilots
                          </h3>
                          <p class="mt-3 text-base leading-6 text-gray-700">
                            Octo Digital drone pilots all hold certified remote pilot licences (RePL) from CASA. We offer both manual and semi-automous surveying.
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
                    <div class="flex-shrink-0">
                      <img class="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1498631906572-66c58d46ecf7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=350&q=100" alt="" />
                    </div>
                    <div class="flex-1 bg-white p-6 flex flex-col justify-between">
                      <div class="flex-1">
                        <p class="text-sm leading-5 font-medium text-indigo-600">
                          <a href="#" class="hover:underline">
                            Infastructure
                          </a>
                        </p>
                        <a href="#" class="block">
                          <h3 class="mt-2 text-xl leading-7 font-semibold text-gray-900">
                            Surveying & Mapping
                          </h3>
                          <p class="mt-3 text-base leading-6 text-gray-500">
                              <ul>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      Construction Insights
                                    </p>
                                  </li>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      Drone driven surveying
                                    </p>
                                  </li>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      Data Analytics for progress of work and safety checks
                                    </p>
                                  </li>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      Custom built solutions
                                    </p>
                                  </li>
                              </ul>
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
                    <div class="flex-shrink-0">
                      <img class="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1517089152318-42ec560349c0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=350&q=100" alt="" />
                    </div>
                    <div class="flex-1 bg-white p-6 flex flex-col justify-between">
                      <div class="flex-1">
                        <p class="text-sm leading-5 font-medium text-indigo-600">
                          <a href="#" class="hover:underline">
                            Mining Industry
                          </a>
                        </p>
                        <a href="#" class="block">
                          <h3 class="mt-2 text-xl leading-7 font-semibold text-gray-900">
                            Logistics & Mapping
                          </h3>
                          <p class="mt-3 text-base leading-6 text-gray-500">
                              </p><ul>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      Business Analysis & Project management
                                      </p>
                                  </li>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      AI & IoT solutions
                                      </p>
                                  </li>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      Analytics implementation
                                      </p>
                                  </li>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      Technical & Product Support
                                      </p>
                                  </li>
                              </ul>
                          <p></p>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
                    <div class="flex-shrink-0">
                      <img class="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1586920740316-3b38ed8f766a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=300&q=100" alt="" />
                    </div>
                    <div class="flex-1 bg-white p-6 flex flex-col justify-between">
                      <div class="flex-1">
                        <p class="text-sm leading-5 font-medium text-indigo-600">
                          <a href="#" class="hover:underline">
                            Data Mining
                          </a>
                        </p>
                        <a href="#" class="block">
                          <h3 class="mt-2 text-xl leading-7 font-semibold text-gray-900">
                            IoT Devices
                          </h3>
                          <p class="mt-3 text-base leading-6 text-gray-500">
                              <ul>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      IoT implementation
                                    </p>
                                  </li>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      Blockchain assets IoT management
                                    </p>
                                  </li>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      Innovation audtion & Strategy
                                    </p>
                                  </li>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      Technical & Product support
                                    </p>
                                  </li>
                              </ul>
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
                    <div class="flex-shrink-0">
                      <img class="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1524813686514-a57563d77965?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=350&q=100" alt="" />
                    </div>
                    <div class="flex-1 bg-white p-6 flex flex-col justify-between">
                      <div class="flex-1">
                        <p class="text-sm leading-5 font-medium text-indigo-600">
                          <a href="#" class="hover:underline">
                            Solutions
                          </a>
                        </p>
                        <a href="#" class="block">
                          <h3 class="mt-2 text-xl leading-7 font-semibold text-gray-900">
                            API Integration
                          </h3>
                         <p class="mt-3 text-base leading-6 text-gray-500">
                              <ul>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      API integration analysis & development
                                    </p>
                                  </li>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      Dashboard design & development
                                    </p>
                                  </li>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      Reliability & Performance analysis
                                    </p>
                                  </li>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      Technical Liaison with API providers
                                    </p>
                                  </li>
                              </ul>
                          </p>
                        </a>
                      </div>
                    </div>
                  </div>
                <div class="flex flex-col rounded-lg shadow-lg overflow-hidden">
                  <div class="flex-shrink-0">
                    <img class="h-48 w-full object-cover" src="https://images.unsplash.com/photo-1492724441997-5dc865305da7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1650&q=80" alt="" />
                  </div>
                  <div class="flex-1 bg-white p-6 flex flex-col justify-between">
                    <div class="flex-1">
                      <p class="text-sm leading-5 font-medium text-indigo-600">
                        <a href="#" target="_blank" class="hover:underline">Web Tools and Growth Hacking
                        </a>
                      </p>
                      <a href="#" class="block">
                          <h3 class="mt-2 text-xl leading-7 font-semibold text-gray-900">
                            Melbourne Specialists
                          </h3>
                         <p class="mt-3 text-base leading-6 text-gray-500">
                              <ul>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      Web development
                                    </p>
                                  </li>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      UI / UX consultants
                                    </p>
                                  </li>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      iOS and Android app development
                                    </p>
                                  </li>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      Network Infrastructure
                                    </p>
                                  </li>
                                  <li class="flex items-start">
                                    <div class="flex-shrink-0">
                                      <svg class="h-6 w-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                                      </svg>
                                    </div>
                                    <p class="ml-3 text-base leading-6 text-gray-700 text-left">
                                      Click here to view our current clients
                                    </p>
                                  </li>
                              </ul>
                          </p>
                        </a>         
                    </div>
                  </div>
                </div>
              </div>
            </div>            

            <br>

            <div class="relative bg-gray-800">
              <div class="h-56 bg-indigo-600 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2">
                <img class="w-full h-full object-cover" src="https://images.unsplash.com/photo-1525130413817-d45c1d127c42?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=60&blend=6875F5&sat=-100&blend-mode=multiply" alt="Support team" />
              </div>
              <div class="relative max-w-screen-xl mx-auto px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
                <div class="md:ml-auto md:w-1/2 md:pl-10">
                  <div class="text-base leading-6 font-semibold uppercase tracking-wider text-gray-300">
                    Unable to find what you need?
                  </div>
                  <h2 class="mt-2 text-white text-3xl leading-9 font-extrabold tracking-tight sm:text-4xl sm:leading-10">
                    We are here to help
                  </h2>
                  <p class="mt-3 text-lg leading-7 text-gray-300">
                    We offer an expert team of specialists, so why not drop us a line?
                    
                  </p>
                  <div class="mt-8">
                    <div class="inline-flex rounded-md shadow">
                      <a href="contact.html" class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-gray-900 bg-white hover:text-gray-600 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out">
                        Go on.. why not send us an email
                        <svg class="-mr-1 ml-3 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"/>
                          <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"/>
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>


        </div> <!-- end tailwind container -->
</template>
<script>
export default {
  title: 'Services | Octo Digital'
}
</script>
